import cx from "classnames"

interface FieldErrorMessageProps {
  children: React.ReactNode
  className?: string
  id: string
}

export function FieldErrorMessage({
  children,
  className,
  id,
  ...props
}: FieldErrorMessageProps) {
  return (
    <p
      id={id}
      role="alert"
      className={cx("c-ruby m-0 mt-1 fs-4", className)}
      {...props}
    >
      {children}
    </p>
  )
}
